export default __webpack_public_path__ + "locales/ru/Translations.json?hash=2241c4de86a08aed1918c88f0c880fae";